import { validate } from '@krugom/validator';
import { setNavigateTo } from '../../../store/reducer';
import store from '../../../store';
import { TValidationScheme } from '@krugom/validator/dist/types';

const navigateTo = (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'string',
    required: true,
    pattern: /^(forwards|back|\/.*)$/,
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return;

  store.dispatch(setNavigateTo(arg));
};

export default navigateTo;
